/* eslint-disable @typescript-eslint/no-unsafe-member-access */

// import { EssayScoreAI, SelectionsProp } from "@/types";
// import countSelectionsProp from "@/utils/count-corrections";
import { uuid } from "@/utils/string.ts";
// import { t } from "i18next";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@edusogno/primitives/toggle-group.js";
import { useEffect, useState } from "react";
// import ParagraphWithCount from "./ParagraphWithCount.tsx";
// import ParagraphWithHighlights from "./ParagraphWithHighlights.tsx";
import { useMore } from "@/contexts/MoreContext.tsx";
import { EssaycheckerResponse } from "@/types/index.ts";
import ParagraphDescription from "./ParagraphDescription";

// const text = `
// Alternative medicine is not new. It is accepted that it pre-dates conventional medicine and it is still used by many people all over the world. I am unconvinced that it is dangerous, and feel that both alternative and conventional medicine can be useful.

// There are several reasons why the conventional medical community is often dismissive of alternatives.  Firstly, there has been little scientific research into such medicine, so there is a scarcity of evidence to support the claims of their supporters. Furthermore, people often try such treatment because of recommendations from friends, and therefore come to the therapist with a very positive attitude, which may be part of the reason for the cure. Moreover, these therapies are usually only useful for long-term, chronic conditions. Acute medical problems, such as accidental injury, often require more conventional methods.

// On the other hand, there remain strong arguments for the use of alternatives.  Despite the lack of scientific proof, there is a lot of anecdotal evidence to suggest that these therapies work. In addition, far from being dangerous, they often have few or no side effects, so the worst outcome would be no change. One of the strongest arguments for the effectiveness of alternative therapies in the West is that, whilst conventional medicine is available without charge, many people are prepared to pay considerable sums for alternatives. If they were totally unhelpful, it would be surprising if this continued.

// I strongly believe that conventional medicine and alternative therapies can and should coexist. They have different strengths, and can both be used effectively to target particular medical problems. The best situation would be for alternative therapies to be used to support and complement conventional medicine.`;

interface Props {
  exerciseCorrectionText?: string[];
  scores?: never;
  grammarCorrections?: never[];
  lexicalCorrections?: never[];
  title: string;
  essaycheckerInfo: EssaycheckerResponse[] | string;
  exerciseRawTextAnswer: string;
  driveKey: string;
}
enum Tools {
  // PARAGRAPH,
  GENERAL_CHECK,
  COHERENCE_CHECK,
  GRAMMAR,
  LEXICAL_CHECK,
}

// TODO: WAITING FOR APIs
const ScoreText = ({
  score = 7.5,
  label = "Task Achievement",
}: {
  score?: number | string;
  label?: string;
}) => {
  return (
    <div className="flex bg-white w-[116px] py-4 px-2 min-h-[63px] rounded-[10px] flex-[1_1_119px] flex-col  items-start">
      <p className=" text-2xl leading-[100%] text-overflow-ellipse text-start font-medium text-brand">
        {score}
      </p>
      <p className="text-xs font-medium text-black">{label}</p>
    </div>
  );
};

export default function DesktopCorrectionWithAI({
  title,
  essaycheckerInfo,
  // exerciseRawTextAnswer: text,
  driveKey,
}: Props) {
  const { isBeta } = useMore();

  //   exerciseCorrectionText, // scores,
  //   // lexicalCorrections,
  // } // grammarCorrections,
  // : Props
  // const countSelectionsProp = () => {};
  // const navigate = useNavigate();
  // const [loading, setLoading] = useState<boolean>(false);
  const [activeTool, setActiveTool] = useState<Tools>(0);
  const [generalText, setGeneralText] = useState<string>("");
  const [coherenceText, setCoherenceText] = useState<string>("");
  const [grammaticalText, setGrammaticalText] = useState<string>("");
  const [lexicalText, setLexicalText] = useState<string>("");

  // TODO: WAITING FOR APIs
  // const toolsArray = ["Paragraphing", "Grammatical check", "Lexical check"];

  const toolsArray = ["General check", "Coherence", "Grammatical", "Lexical"];

  useEffect(() => {
    if (isBeta)
      JSON.parse(essaycheckerInfo as unknown as string).forEach(
        (el: { id: string; desc: string }) => {
          if (el.id === "tr") setGeneralText(el.desc);
          if (el.id === "cc") setCoherenceText(el.desc);
          if (el.id === "gr") setGrammaticalText(el.desc);
          if (el.id === "lr") setLexicalText(el.desc);
        },
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const { t } = useTranslation();
  // const [displaySlider, setDisplaySlider] = useState(false);

  // const Slider = ({
  //   value,
  //   total,
  //   label,
  //   labelValue,
  // }: {
  //   value: number;
  //   total: number;
  //   label: string;
  //   labelValue: number;
  // }) => {
  //   return (
  //     <div className="w-fit">
  //       <div className="flex items-center justify-between mb-2">
  //         <p className="text-[10px]">{label}</p>
  //         <p className="text-[#219653] font-semibold">{labelValue}</p>
  //       </div>
  //       <div className="flex w-[164px] bg-[#D3EADD] h-2 rounded-full mb-4 ">
  //         <div
  //           className={cn("bg-[#219653] h-2 rounded-full flex")}
  //           style={{ width: `${(value / total) * 100}%` }}
  //         ></div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div
      className={
        "h-full until-xl:overflow-y-auto w-full xl:flex-[1_1_40%] flex flex-col justify-between gap-4 "
      }
    >
      {/* <div className={"space-y-2 w-full  mb-6 "}> */}
      {/* <div className="flex flex-[1_1_100%] flex-col h-full"> */}
      {/* <p className={"text-light text-[20px] font-semibold"}>
            {t("exercises.correct_with_ai_page.title")}
          </p>
          <p className={"text-light text-sm mb-[30px]"}>
            {t("exercises.correct_with_ai_page.description")}
          </p> */}
      {/* <button
            className="flex items-center gap-4 pl-4 pr-6 py-2 border-2 border-white rounded-[7px] mb-6"
            onClick={() => navigate("../../")}
          >
            <ChevronLeft color="#fff" />
            <p className="text-white">{t("btns.back")}</p>
          </button> */}
      {/* TODO: WAITING FOR APIS */}
      {isBeta && (
        <div className="flex flex-row w-full h-fif">
          <div className="hidden xl:flex fex-row rounded-[7px] w-full gap-4">
            {JSON.parse(essaycheckerInfo as unknown as string).map(
              (el: EssaycheckerResponse, i: number) =>
                el.title !== "Recommendations" && (
                  <ScoreText
                    key={"box-score-title-" + i}
                    label={el.title}
                    score={el.score}
                  />
                ),
            )}
            {/* <ScoreText
              label="Task Achievement"
              // label={t("exercises.correct_with_ai_page.task_achievement")}
              score={7.5}
            />
            <ScoreText
              label="Coherence and cohesion"
              // label={t("exercises.correct_with_ai_page.coherence_coheson")}
              score={7.5}
            />
            <ScoreText
              label="Lexical resource"
              // label={t("exercises.correct_with_ai_page.lexical_resource")}
              score={7.5}
            />
            <ScoreText
              label="Grammatical accuracy"
              // label={t("exercises.correct_with_ai_page.grammatical_accuracy")}
              score={7.5}
            /> */}
          </div>

          <div className="flex text-black  min-h-[80px] justify-center p-4 font-medium text-xs w-full rounded-[10px] bg-white/80 flex-col xl:hidden">
            {JSON.parse(essaycheckerInfo as unknown as string).map(
              (el: EssaycheckerResponse, i: number) =>
                el.title !== "Recommendations" && (
                  <div
                    key={"box-score-" + i}
                    className="flex flex-row items-center justify-between"
                  >
                    <p>{el.title}</p>
                    <p className="font-semibold">{el.score}</p>
                  </div>
                ),
            )}
            {/* <div className="flex flex-row items-center justify-between">
              <p>Task achievement</p>
              <p className="font-semibold">8.0</p>
            </div>
            <div className="flex flex-row items-center justify-between">
              <p>Coherence and cohesion</p>
              <p className="font-semibold">8.0</p>
            </div>
            <div className="flex flex-row items-center justify-between">
              <p>Lexical resource</p>
              <p className="font-semibold">8.0</p>
            </div>
            <div className="flex flex-row items-center justify-between">
              <p>Grammatical accuracy</p>
              <p className="font-semibold">8.0</p>
            </div> */}
          </div>
        </div>
      )}
      {/* TODO: WAITING FOR APIS */}
      {isBeta && (
        <div>
          <ToggleGroup
            type="single"
            value={String(activeTool)}
            onValueChange={(idx) => setActiveTool(Number(idx))}
            className="flex flex-row w-full gap-2 mt-2"
          >
            {toolsArray.map((value, idx) => (
              <ToggleGroupItem
                key={uuid()}
                value={String(idx)}
                className=" bg-[--primary300] w-full data-[state=on]:text-secondary data-[state=on]:text-white data-[state=on]:bg-primary xl:rounded-[15px] rounded-[10px] h-[50px] xl:h-[27px] flex flex-row gap-4 px-2 items-center flex justify-center items-center text-black text-xs font-semibold"
              >
                <p>{value}</p>
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </div>
      )}
      {/* <div className="w-full flex-[1_1_100%] flex gap-2"> */}
      {/* <div className="flex flex-row"> */}
      {/* {loading && ( */}

      {/* )} */}
      {/* {!loading && (
              <div>
                <Button
                  className="w-full text-base  hover:bg-brand-deep"
                  onClick={() => {
                    setLoading(true);
                    setDisplaySlider(true);
                  }}
                >
                  Analyze
                </Button>
              </div>
            )} */}
      {/* </div> */}
      {/* <div className="flex-auto w-full h-full"> */}
      <div className="text-black h-full flex  flex-col bg-white px-3 py-4  rounded-[7px]">
        {/* {exerciseCorrectionText.map((text: string, index: number) => (
              <>
                {displaySlider && activeTool == null && (
                  <div className="absolute bottom-0 left-0 flex w-full gap-8 px-4 bg-white">
                    <Slider
                      value={4}
                      total={5}
                      label="Paragraphs"
                      labelValue={5}
                    />
                    <Slider
                      value={120}
                      total={150}
                      label="Words"
                      labelValue={120}
                    />
                  </div>
                )}
                {activeTool == null && (
                  <p key={index} className="mb-4 rounded-none">
                    {text}
                  </p>
                )}

              </>
            ))} */}
        {/* <PDFViewer fileBase64={file} /> */}
        {!isBeta && (
          <iframe
            loading="lazy"
            width={"100%"}
            height={"100%"}
            className="col-span-2"
            title={title}
            src={`https://docs.google.com/file/d/${driveKey}/preview?usp=drivesdk`}
          />
        )}
        {isBeta && (
          <>
            {activeTool === Tools.GENERAL_CHECK && (
              <ParagraphDescription text={generalText} />
            )}
            {activeTool === Tools.COHERENCE_CHECK && (
              <ParagraphDescription text={coherenceText} />
            )}
            {activeTool === Tools.GRAMMAR && (
              <ParagraphDescription text={grammaticalText} />
            )}
            {activeTool === Tools.LEXICAL_CHECK && (
              <ParagraphDescription text={lexicalText} />
            )}
            {/* {activeTool == Tools.PARAGRAPH && (
              <ParagraphWithCount
                text={text}
                key={1}
                paragraphCount={text.length}
                currentParagraphIndex={1}
              />
            )}
            {activeTool == Tools.GRAMMAR && (
              <ParagraphWithHighlights
                text={text}
                highlights={[{ start_index: 10, end_index: 12 }]}
              />
            )}
            {activeTool == Tools.LEXICAL_CHECK && (
              <ParagraphWithHighlights
                text={text}
                highlights={[{ start_index: 0, end_index: 10 }]}
              />
            )} */}
          </>
        )}
      </div>
      {/* </div> */}

      {/* {!loading && (
              <div>
                <Button
                  className="w-full text-base  hover:bg-brand-deep"
                  onClick={() => {
                    setLoading(true);
                    setDisplaySlider(true);
                  }}
                >
                  Analyze
                </Button>
              </div>
            )} */}
    </div>
  );
}
